var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as bootstrap from 'bootstrap';
import { generateQR } from './services/qr-generate';
import { startScanner, stopScanner } from './services/qr-scan';
import { createMessage, processScannedMessage, setDisplayName, setLastMessage, isDuplicateMessage, registerMessageId, } from './services/chat-state';
import { hashMessage } from './utils/hash';
import { view, chat, qr, scan, toast, btn } from './utils/dom-elements';
import faviconUrl from './assets/favicon.png';
const chatHistory = [];
let currentJson = '';
let scanner = null;
let phase = 'compose';
let lastSentHash = null;
// Set favicon (imported via Webpack asset pipeline)
document.getElementById('favicon-link').href = faviconUrl;
document.getElementById('navbar-icon').src = faviconUrl;
function setPhase(newPhase) {
    phase = newPhase;
    // Hide all views first
    [view.onboarding, view.chat, view.displayQr, view.scan].forEach((v) => v.classList.add('d-none'));
    if (newPhase === 'onboarding') {
        showView(view.onboarding);
    }
    else if (newPhase === 'compose') {
        chat.inputMessage.disabled = false;
        chat.inputMessage.placeholder = 'Type a message...';
        btn.send.disabled = false;
        btn.showQrFromScan.classList.remove('d-none');
        showView(view.chat);
    }
    else if (newPhase === 'awaiting_response') {
        btn.showQrFromScan.classList.remove('d-none');
        chat.inputMessage.disabled = true;
        chat.inputMessage.placeholder = 'Waiting for response...';
        btn.send.disabled = true;
        showView(view.displayQr);
    }
    else if (newPhase === 'scan_only') {
        // Receiver mode: only scanner is available, no chat input, no QR to show
        chat.inputMessage.disabled = true;
        chat.inputMessage.placeholder = 'Scan a message first...';
        btn.send.disabled = true;
        btn.showQrFromScan.classList.add('d-none');
        showScanView();
        void startScan();
    }
}
function showQrView() {
    if (phase !== 'awaiting_response')
        return;
    stopScan();
    [view.onboarding, view.chat, view.displayQr, view.scan].forEach((v) => v.classList.add('d-none'));
    view.displayQr.classList.remove('d-none');
}
function showScanView() {
    if (phase !== 'awaiting_response' && phase !== 'scan_only')
        return;
    [view.onboarding, view.chat, view.displayQr, view.scan].forEach((v) => v.classList.add('d-none'));
    view.scan.classList.remove('d-none');
}
function showView(targetView) {
    [view.chat, view.displayQr, view.scan].forEach((v) => v.classList.add('d-none'));
    targetView.classList.remove('d-none');
}
function showToast(message) {
    toast.body.textContent = message;
    const bsToast = new bootstrap.Toast(toast.el);
    bsToast.show();
}
function formatTime(ts) {
    return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
function appendBubble(msg, direction) {
    const wrapper = document.createElement('div');
    wrapper.className = `chat-msg msg-${direction}`;
    const meta = document.createElement('div');
    meta.className = 'chat-meta text-muted';
    const name = msg.display_name || 'Anonymous';
    meta.textContent = `${name} · ${formatTime(msg.timestamp)}`;
    const bubble = document.createElement('div');
    bubble.className = 'chat-bubble';
    // All messages start redacted, only the newest will be revealed after append
    const realSpan = document.createElement('span');
    realSpan.className = 'msg-real';
    realSpan.textContent = msg.msg_content;
    const redactedSpan = document.createElement('span');
    redactedSpan.className = 'msg-redacted-dots';
    redactedSpan.textContent = '•'.repeat(msg.msg_content.length);
    bubble.appendChild(realSpan);
    bubble.appendChild(redactedSpan);
    wrapper.appendChild(meta);
    wrapper.appendChild(bubble);
    chat.messages.appendChild(wrapper);
    // Auto-scroll to bottom
    chat.history.scrollTop = chat.history.scrollHeight;
    // Update redaction: hide all messages, reveal only the newest
    updateRedaction();
}
// Update redacted msgs
function updateRedaction() {
    const allBubbles = chat.messages.querySelectorAll('.chat-bubble');
    // Hide all messages (show redacted dots, hide real content)
    allBubbles.forEach((b) => {
        b.classList.add('msg-redacted');
    });
    // Reveal only the very last message
    if (allBubbles.length > 0) {
        const last = allBubbles[allBubbles.length - 1];
        last.classList.remove('msg-redacted');
    }
}
// Send message
btn.send.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
    if (phase !== 'compose')
        return;
    const content = chat.inputMessage.value.trim();
    if (!content) {
        showToast('Please enter a message.');
        return;
    }
    const name = chat.inputName.value.trim();
    if (name) {
        setDisplayName(name);
    }
    const msg = yield createMessage(content);
    chatHistory.push({ msg, direction: 'sent' });
    appendBubble(msg, 'sent');
    currentJson = JSON.stringify(msg);
    lastSentHash = yield hashMessage(currentJson);
    registerMessageId(msg.msg_id);
    yield generateQR(currentJson, qr.container);
    chat.inputMessage.value = '';
    setPhase('awaiting_response');
}));
function startScan() {
    return __awaiter(this, void 0, void 0, function* () {
        if (phase !== 'awaiting_response' && phase !== 'scan_only')
            return;
        showScanView();
        scan.error.classList.add('d-none');
        try {
            scanner = yield startScanner('scanner-container', (decodedText) => __awaiter(this, void 0, void 0, function* () {
                const msg = processScannedMessage(decodedText);
                if (!msg) {
                    showToast('Invalid QR code data.');
                    yield restartScan();
                    return;
                }
                if (isDuplicateMessage(msg.msg_id)) {
                    showToast('Already received this message.');
                    yield restartScan();
                    return;
                }
                if (lastSentHash !== null && msg.last_hash !== lastSentHash) {
                    showToast('Response does not match last message.');
                    yield restartScan();
                    return;
                }
                // Valid response, stop scanner immediately, then transition
                yield stopScan();
                registerMessageId(msg.msg_id);
                setLastMessage(msg);
                chatHistory.push({ msg, direction: 'received' });
                appendBubble(msg, 'received');
                lastSentHash = null;
                setPhase('compose');
            }), (err) => __awaiter(this, void 0, void 0, function* () {
                scan.error.textContent = err;
                scan.error.classList.remove('d-none');
                yield restartScan();
            }));
        }
        catch (err) {
            const errMsg = err instanceof Error ? err.message : 'Failed to start scanner.';
            scan.error.textContent = errMsg;
            scan.error.classList.remove('d-none');
            yield restartScan();
        }
    });
}
function restartScan() {
    return __awaiter(this, void 0, void 0, function* () {
        if (phase !== 'awaiting_response' && phase !== 'scan_only')
            return;
        yield stopScan();
        yield startScan();
    });
}
function stopScan() {
    return __awaiter(this, void 0, void 0, function* () {
        if (scanner) {
            yield stopScanner(scanner);
            scanner = null;
        }
    });
}
// Event listeners
btn.onboardingSend.addEventListener('click', () => setPhase('compose'));
btn.onboardingScan.addEventListener('click', () => setPhase('scan_only'));
btn.scanResponse.addEventListener('click', () => void startScan());
btn.showQrFromScan.addEventListener('click', () => showQrView());
chat.inputMessage.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        btn.send.click();
    }
});
// Startup
setPhase('onboarding');
